import React from "react";
import { Backdrop, CircularProgress } from "@mui/material";
import PropTypes from "prop-types";

function LoaderOverlay({ open, size = 80, thickness = 4 }) {
  return (
    <Backdrop
      sx={{
        color: "#fff",
        zIndex: (theme) => theme.zIndex.drawer + 9999,
        backgroundColor: "rgba(255,255,255,0.5)",
      }}
      open={open}
    >
      <CircularProgress color="primary" size={size} thickness={thickness} sx={{ color: "#018EA1" }} />
    </Backdrop>
  );
}

LoaderOverlay.propTypes = {
  open: PropTypes.bool.isRequired,
  size: PropTypes.number,
  thickness: PropTypes.number,
};

export default LoaderOverlay;
